import { render, staticRenderFns } from "./ResultExportStatusBadge.vue?vue&type=template&id=0921ab08"
import script from "./ResultExportStatusBadge.vue?vue&type=script&lang=js"
export * from "./ResultExportStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports